import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    theme: localStorage.getItem('theme') || 'light',
    specificationsDashboard: 'grid',
    specPreviewComponents: 'list',
    orderCollectionsTimelinePeriod: 'week',
    showMenu: false,
    breadcrumbs: [],
    showModals: [],
    showSidebars: [],
};
const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        toggleTheme: (state) => {
            state.theme = state.theme === 'light' ? 'dark' : 'light';
        },
        setShowMenu: (state, action) => {
            state.showMenu = action.payload;
        },
        toggleShowMenu: (state) => {
            state.showMenu = !state.showMenu;
        },
        setSpecificationsDashboard: (state, action) => {
            state.specificationsDashboard = action.payload;
        },
        toggleSpecificationsDashboard: (state) => {
            state.specificationsDashboard = state.specificationsDashboard === 'list' ? 'grid' : 'list';
        },
        toggleSpecPreviewComponents: (state) => {
            state.specPreviewComponents = state.specPreviewComponents === 'list' ? 'grid' : 'list';
        },
        setOrderCollectionsTimelinePeriod: (state, action) => {
            state.orderCollectionsTimelinePeriod = action.payload;
        },
        // breadcrumbs actions
        setBreadcrumbs: (state, action) => {
            state.breadcrumbs = action.payload;
        },
        clearBreadcrumbs: (state) => {
            state.breadcrumbs = [];
        },
        // modal actions
        openModal: (state, action) => {
            const existing = state.showModals.find((modal) => modal.name === action.payload.name);
            if (!existing) {
                state.showModals.push(Object.assign(Object.assign({}, action.payload), { opened: true, active: false }));
            }
        },
        activateModal: (state, action) => {
            const modal = state.showModals.find((modal) => modal.name === action.payload.name);
            if (modal) {
                modal.active = true;
            }
        },
        closeModal: (state, action) => {
            const modal = state.showModals.find((modal) => modal.name === action.payload.name);
            if (modal) {
                modal.active = false;
            }
        },
        removeModal: (state, action) => {
            state.showModals = state.showModals.filter((modal) => modal.name !== action.payload.name);
        },
        // sidebar actions
        openSidebar: (state, action) => {
            const existing = state.showSidebars.find((sidebar) => sidebar.name === action.payload.name);
            if (!existing) {
                state.showSidebars.push(Object.assign(Object.assign({}, action.payload), { opened: true, active: false }));
            }
        },
        activateSidebar: (state, action) => {
            const sidebar = state.showSidebars.find((sidebar) => sidebar.name === action.payload.name);
            if (sidebar) {
                sidebar.active = true;
            }
        },
        closeSidebar: (state, action) => {
            const sidebar = state.showSidebars.find((sidebar) => sidebar.name === action.payload.name);
            if (sidebar) {
                sidebar.active = false;
            }
        },
        removeSidebar: (state, action) => {
            state.showSidebars = state.showSidebars.filter((sidebar) => sidebar.name !== action.payload.name);
        },
        closeAllSidebars: (state) => {
            state.showSidebars = state.showSidebars.map((sidebar) => (Object.assign(Object.assign({}, sidebar), { active: false })));
        },
        removeAllSidebars: (state) => {
            state.showSidebars = [];
        },
    },
});
export const { setTheme, toggleTheme, setShowMenu, toggleShowMenu, setSpecificationsDashboard, toggleSpecificationsDashboard, toggleSpecPreviewComponents, setOrderCollectionsTimelinePeriod, setBreadcrumbs, clearBreadcrumbs, openModal, activateModal, closeModal, removeModal, openSidebar, activateSidebar, closeSidebar, removeSidebar, closeAllSidebars, removeAllSidebars, } = layoutSlice.actions;
export const selectLayout = (state) => state.layout;
export const selectOrderCollectionsTimelinePeriod = (state) => state.layout.orderCollectionsTimelinePeriod;
export const selectModal = (state) => state.layout.showModals;
export const selectModals = (state) => state.layout.showModals;
export const selectModalByName = (name) => (state) => state.layout.showModals.find((modal) => modal.name === name);
export const selectSidebars = (state) => state.layout.showSidebars;
export const selectSidebarByName = (name) => (state) => state.layout.showSidebars.find((sidebar) => sidebar.name === name);
export const selectBreadcrumbs = (state) => state.layout.breadcrumbs;
export default layoutSlice.reducer;
